<template>
  <el-card
    class="box-card download-card"
    shadow="never"
  >
    <template #header>
      <span class="card-title">App Download</span>
    </template>
    <div class="download-list">
      <a
        class="download-item"
        href="https://csmaw01.slamdunknoone.com/cdn/client/win/pigen-087.exe"
      >
        <el-icon class="dl-icon">
          <Icon icon="cib:windows" />
        </el-icon>
        <div class="dl-text">
          <span class="dl-name">Windows Client</span>
          <span class="dl-sub">pigen-087.exe</span>
        </div>
      </a>
      <a
        class="download-item"
        href="https://csmaw01.slamdunknoone.com/cdn/client/win/pigen-087.dmg"
      >
        <el-icon class="dl-icon">
          <Icon icon="mdi:apple" />
        </el-icon>
        <div class="dl-text">
          <span class="dl-name">macOS Client</span>
          <span class="dl-sub">pigen-087.dmg</span>
        </div>
      </a>
    </div>
  </el-card>
</template>

<script setup>
import { Icon } from '@iconify/vue'
</script>

<style scoped>
.card-title {
  font-size: 16px;
  font-weight: 600;
}
.download-card {
  height: 100%;
}
.download-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 0;
}
.download-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--el-border-color-lighter, #ebeef5);
  border-radius: 8px;
  text-decoration: none;
  color: var(--el-text-color-primary, #303133);
  transition: all 0.2s ease;
}
.download-item:hover {
  border-color: var(--el-color-primary, #409eff);
  color: var(--el-color-primary, #409eff);
  background: var(--el-color-primary-light-9, #ecf5ff);
}
.dl-icon {
  font-size: 24px;
  flex-shrink: 0;
}
.dl-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  min-width: 0;
}
.dl-name {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-sub {
  font-size: 12px;
  color: var(--el-text-color-secondary, #909399);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
